import i18n from '@opsbase/lib-i18n';
import useSelf from '@opsbase/react-ctrl-self/useSelf';
import useGenerateOpDetailsReportPDF from '@opsbase/react-gql-hooks/op/useGenerateOpDetailsReportPDF';
import markdown from '@opsbase/react-markdown';
import Dialog from '@opsbase/web-dialogs/Dialog';
import useNav from '@opsbase/web-nav/useNav';
import useParams from '@opsbase/web-nav/useParams';
import useTaskWatcherActions from '@opsbase/web-taskwatcher/useTaskWatcherActions';
import TextFieldWithEmails from '@opsbase/web-textfield/TextFieldWithEmails';
import Button from '@opsbase/web-ui/Button';
import Text from '@opsbase/web-ui/Text';
import React, { useCallback, useState } from 'react';
export function OpGenerateDetailsReportDialog() {
    const { id } = useParams();
    const self = useSelf();
    const [isStarting, setIsStarting] = useState(false);
    const [emails, setEmails] = useState([self.email]);
    const { goBack } = useNav();
    const { watchTasks } = useTaskWatcherActions();
    const generateOpDetailsReportPDF = useGenerateOpDetailsReportPDF();
    const handleClickStart = useCallback(async () => {
        setIsStarting(true);
        const task = await generateOpDetailsReportPDF({
            id,
            email: emails.join(';'),
        });
        watchTasks([task]);
        goBack();
    }, [emails, generateOpDetailsReportPDF, goBack, id, watchTasks]);
    return (React.createElement(Dialog, { title: i18n.t('op-generatedetailpdf'), buttonsRight: React.createElement(Button, { disabled: !(emails === null || emails === void 0 ? void 0 : emails.length), label: isStarting ? '' : i18n.t('op-generatedetailpdf'), loading: isStarting, onClick: handleClickStart }) },
        React.createElement(Text, null, markdown(i18n.t('confirm-op-details'))),
        React.createElement(TextFieldWithEmails, { placeholder: i18n.t('enter-email-addresses'), value: emails, onChange: setEmails, fullWidth: true })));
}
export default OpGenerateDetailsReportDialog;
